import { render } from "./billing-periods.vue?vue&type=template&id=63683dca"
import script from "./billing-periods.vue?vue&type=script&lang=js"
export * from "./billing-periods.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__